import React, {
  useEffect,
  useState
} from "react";

import {
  Link
} from "react-router-dom";

import axios from "axios";

import {
  API_URL,
  getMediaUrl
} from "../config/api";


function MostRead() {

  const [
    mostRead,
    setMostRead
  ] = useState([]);

  const [
    loading,
    setLoading
  ] = useState(true);

  const [
    error,
    setError
  ] = useState("");


  useEffect(() => {

    const fetchMostRead =
      async () => {

        try {

          setLoading(true);
          setError("");

          const response =
            await axios.get(
              `${API_URL}/api/most-read`
            );

          setMostRead(
            Array.isArray(
              response.data
            )
              ? response.data
              : []
          );

        }

        catch (err) {

          console.error(
            "Error loading most read:",
            err
          );

          setError(
            "Unable to load Most Read right now."
          );

        }

        finally {

          setLoading(false);

        }

      };


    fetchMostRead();

  }, []);


  const getSubcategoryLabel =
    (subcategory) => {

      if (
        subcategory ===
        "Science"
      ) {
        return "Science & Technology";
      }

      if (
        subcategory === "Cultural" ||
        subcategory === "Culture"
      ) {
        return "Ink and Echo";
      }

      return subcategory;

    };


  const getMostReadLink =
    (item) => {

      if (!item) {
        return "/";
      }


      if (
        item.contentType ===
        "post"
      ) {

        return `/post/${item._id}`;

      }


      if (
        item.contentType ===
        "publication"
      ) {

        if (item.pdf) {

          return getMediaUrl(
            item.pdf
          );

        }


        if (
          item.type === "book"
        ) {

          return "/publications/books";

        }


        if (
          item.type ===
          "newspaper"
        ) {

          return "/publications/newspapers";

        }


        if (
          item.type ===
          "magazine"
        ) {

          return "/publications/magazines";

        }

      }


      return "/";

    };


  const getItemLabel =
    (item) => {

      if (
        item.contentType ===
        "publication"
      ) {

        if (
          item.type === "book"
        ) {
          return "Book";
        }


        if (
          item.type ===
          "newspaper"
        ) {
          return "Newspaper";
        }


        if (
          item.type ===
          "magazine"
        ) {
          return "Magazine";
        }


        return "Publication";

      }


      if (
        item.subcategory
      ) {

        return (
          `${item.category} / ` +
          getSubcategoryLabel(
            item.subcategory
          )
        );

      }


      return (
        item.category ||
        "Post"
      );

    };


  return (

    <main className="most-read-page">

      <div className="most-read-container">

        <div className="most-read-heading">

          <span className="most-read-eyebrow">
            Reader favourites
          </span>

          <h1>
            Most Read
          </h1>

          <p>
            The stories and publications
            receiving the most attention
            from readers.
          </p>

        </div>


        {loading ? (

  <p
    className="most-read-status"
    role="status"
    aria-live="polite"
  >
    Loading Most Read...
  </p>

) : error ? (

          <p
            className=
              "most-read-status most-read-error"
          >
            {error}
          </p>

        ) : mostRead.length === 0 ? (

          <p className="most-read-status">
            No reading data yet.
          </p>

        ) : (

          <div className="most-read-list">

            {mostRead.map(
              (item, index) => {

                const link =
                  getMostReadLink(
                    item
                  );

                const label =
                  getItemLabel(
                    item
                  );

                const isPublication =
                  item.contentType ===
                  "publication";


                const content = (

                  <div
                    className=
                      "most-read-card"
                  >

                    <div
                      className=
                        "most-read-rank"
                    >
                      {String(
                        index + 1
                      ).padStart(
                        2,
                        "0"
                      )}
                    </div>


                    <div
                      className=
                        "most-read-card-content"
                    >

                      <span
                        className=
                          "most-read-category"
                      >
                        {label}
                      </span>

                      <h2>
                        {item.title}
                      </h2>

                      <span
                        className=
                          "most-read-open"
                      >
                        {isPublication
                          ? "Open Publication"
                          : "Read Article"}
                      </span>

                    </div>

                  </div>

                );


                if (
                  isPublication &&
                  item.pdf
                ) {

                  return (

                    <a
                      key={
                        `${item.contentType}-${item._id}`
                      }
                      href={link}
                      target="_blank"
                      rel="noreferrer"
                      className=
                        "most-read-card-link"
                    >
                      {content}
                    </a>

                  );

                }


                return (

                  <Link
                    key={
                      `${item.contentType}-${item._id}`
                    }
                    to={link}
                    className=
                      "most-read-card-link"
                  >
                    {content}
                  </Link>

                );

              }
            )}

          </div>

        )}

      </div>

    </main>

  );

}


export default MostRead;